import React, { useState, useEffect, useRef } from 'react';

const LazyImage = ({ src, alt, className, onClick, thumbnailUrl }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isInView, setIsInView] = useState(false);
  const imgRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsInView(true);
            observer.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: '200px', // Start loading 200px before the image enters viewport
        threshold: 0.01
      }
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => {
      if (imgRef.current) {
        observer.unobserve(imgRef.current);
      }
    };
  }, []);

  return (
    <div ref={imgRef} className="relative w-full">
      {!isLoaded && (
        <div className="w-full aspect-square bg-gray-200 animate-pulse rounded" />
      )}
      {isInView && (
        <img
          src={thumbnailUrl || src}
          alt={alt}
          onClick={onClick}
          className={`${className} ${isLoaded ? 'opacity-100' : 'opacity-0'} transition-opacity duration-300`}
          onLoad={() => setIsLoaded(true)}
          style={!isLoaded ? { position: 'absolute', top: 0, left: 0 } : {}}
        />
      )}
    </div>
  );
};

export default LazyImage;
